export default __webpack_public_path__ + "static/phpDev-5e73ff65c0f692445b64312232a61800.jpg";